<template>
  <div class="q-pa-lg text-weight-medium bg-primary-light full-width">
    <p class="text-body text-weight-medium text-center">
      {{ name }}
    </p>
    <h2 class="text-weight-medium text-grey-10 q-mt-sm text-center">
      {{ price | currency }}
    </h2>
    <div class="row justify-center">
      <SAIBtn
        :disable="disable"
        label="Select Price"
        class="q-mt-md"
        outline
        :rounded="false"
        @click="$emit('select', price)"
      />
    </div>
  </div>
</template>

<script>
import { SAIBtn } from 'ecx.saigon.ui.common';

export default {
  name: 'DealerPriceCard',
  props: {
    disable: Boolean,
    name: String,
    price: Number
  },
  components: {
    SAIBtn
  }
};
</script>
